<span class="inner-content">
    <ng-content></ng-content>
</span>
